import React, { useState } from "react";
import { BsUpload } from "react-icons/bs";
import { LiaTimesSolid } from "react-icons/lia";
import AlertMessage from "../../../../components/alert/AlertMessage";
import Loading from "../../../../components/loading/Loading";
import { ERROR_MSG, MODE } from "../../../../constants/common";
import {
    RESET_LOADER,
    SET_ERROR,
    SET_LOADER,
} from "../../../../constants/contexConstant";
import {
    UPLOAD_CONSUMER_PAYMENT_DETAILS_ENDPOINT,
    UPLOAD_CONSUMER_PAYMENT_ENDPOINT,
} from "../../../../constants/routes";
import { useContextState } from "../../../../context/ContextProvider";
import useFileUploadAndRemove from "../../../../hooks/useFileUploadAndRemove";
import { checkAnimation } from "../../../../resources/js/gifs";
import request from "../../../../services/request";
import Container from "../../../../shared/Container";
import H4 from "../../../../shared/typography/H4";
import P from "../../../../shared/typography/P";
import Button from "../../../../shared/ui/Button";
import BottomDrawer from "../../../../shared/ui/Drawer/BottomDrawer";
import LabeledInput from "../../../../shared/ui/Form/LabeledInput";
import { renderFileIcons } from "../../../../utils/fileUtils";
import PaymentCard from "../PaymentCard";
import PaymentHistory from "../PaymentHistory";

const Confirmation = ({ onClick, data, history, paymentMode }) => {
    const [amount, setAmount] = useState("");
    const [amountError, setAmountError] = useState("");
    const [isSuccess, setIsSuccess] = useState(false);
    const [showHistory, setShowHistory] = useState(false);
    const { dispatch } = useContextState();

    const { file, uploadedDoc, uploading, handleFileChange, removeFile } =
        useFileUploadAndRemove(UPLOAD_CONSUMER_PAYMENT_DETAILS_ENDPOINT, null);

    const handleChangeAmount = (e) => {
        const val = e.target.value;
        setAmount(val);

        if (!val) {
            setAmountError("Value must be numeric");
        } else if (isNaN(val)) {
            setAmountError("Value must be number");
        } else if (val < 0 || val > data?.amountDue) {
            setAmountError(`Value must be positive  max is ${data?.amountDue}`);
        } else {
            setAmountError("");
        }
    };

    const handleChangeFileInput = async (e) => {
        await handleFileChange(e);
        // setTimeout(() => {
        //     emptyDivRef.current.scrollIntoView({
        //         behavior: "smooth",
        //         block: "end",
        //         inline: "end",
        //         offset: 10,
        //     });
        // }, [100]);
    };

    const handleUploadPaymentDetails = async () => {
        try {
            let paymentType =
                paymentMode === MODE.upi ? "bank_transfer" : "cheque";
            dispatch({ type: SET_LOADER });
            await request.authPost({
                endpoint: `${UPLOAD_CONSUMER_PAYMENT_ENDPOINT}/${paymentType}`,
                body: {
                    amount: amount,
                    fileId: uploadedDoc[0].file,
                },
            });
            setIsSuccess(true);
            dispatch({ type: RESET_LOADER });
        } catch (error) {
            dispatch({ type: RESET_LOADER });
            dispatch({
                type: SET_ERROR,
                payload: typeof error === "string" ? error : ERROR_MSG,
            });
        }
    };

    return (
        <div className="flex justify-between font-urbanist gap-2 xl:gap-4">
            <div className="w-full lg:w-4/5 flex flex-col gap-y-2.4">
                {isSuccess ? (
                    <div className="flex flex-col items-center w-full min-h-[50vh] gap-y-6.4">
                        <P className="font-normal lg:font-semibold font-vietnam  lg:font-urbanist text-center ">
                            Thanks for your payment !
                        </P>

                        <img
                            src={checkAnimation}
                            alt="Completed"
                            className="w-10.4 h-10.4"
                        />
                        <P className="font-normal lg:font-semibold font-vietnam  lg:font-urbanist text-center">
                            Will confirm your payment soon
                        </P>
                    </div>
                ) : data ? (
                    <>
                        <PaymentCard
                            heading={data?.name}
                            status={data?.status}
                            statusType={
                                data?.status === "PAID" ? "success" : "warn"
                            }
                            due={data?.amountDue}
                            paid={data?.amountPaid}
                            isSelected={true}
                        />
                        <P className="font-normal lg:font-semibold font-vietnam  lg:font-urbanist ">
                            Already Paid? Tell us a payment amount and upload
                            payment confirmation receipt
                        </P>
                        <LabeledInput
                            errorMessage={amountError}
                            wrapperClassName="!mb-0"
                            placeholder="XXXXXXXX"
                            value={amount}
                            onChange={handleChangeAmount}
                            label="Payment Amount"
                        />
                        <div className="mt-1 ">
                            {uploadedDoc.length === 0 && (
                                <>
                                    {uploading ? (
                                        <P className="text-center flex justify-center">
                                            <Loading />
                                        </P>
                                    ) : (
                                        <>
                                            <P className="mb-0.5 xl:text-sm 2xl:text-sm">
                                                File Upload
                                            </P>
                                            <label
                                                role="button"
                                                className="border border-blue-400 rounded-lg p-0.5 px-0-0.2 w-full text-center flex items-center justify-center cursor-pointer mb-0.4"
                                                htmlFor="fileUploadInput"
                                            >
                                                <P className="flex items-center gap-0.4 xl:text-sm 2xl:text-base text-secondary">
                                                    <BsUpload />
                                                    Click here to upload file
                                                </P>
                                            </label>
                                        </>
                                    )}
                                    {/* Hidden File Input */}
                                    <input
                                        type="file"
                                        id="fileUploadInput"
                                        name="fileUploadInput"
                                        onClick={(e) => (e.target.value = null)}
                                        onChange={(e) =>
                                            handleChangeFileInput(e)
                                        }
                                        className="hidden"
                                    />
                                </>
                            )}

                            <div className="flex flex-col-reverse">
                                {file.length > 0 &&
                                    file.map((doc, index) => (
                                        <div
                                            key={index}
                                            className="flex justify-between items-center border border-blue-400 bg-gray-100 rounded-lg p-1 py-0.5 mb-0.5 gap-0.2"
                                        >
                                            <div className="flex items-center gap-0.5">
                                                <div className="text-xxl mr-0.5 text-gray-140 ">
                                                    {renderFileIcons(doc.name)}
                                                </div>
                                                <P className="text-secondary xl:text-sm 2xl:text-sm truncate w-[230px] ">
                                                    {doc.name}
                                                </P>
                                            </div>
                                            <button
                                                onClick={() =>
                                                    removeFile(index)
                                                }
                                                className="text-red-500 hover:text-red-700 text-xl"
                                            >
                                                <LiaTimesSolid />
                                            </button>
                                        </div>
                                    ))}
                            </div>
                        </div>
                        <Button
                            disabled={
                                uploadedDoc.length === 0 ||
                                amountError ||
                                isNaN(amount)
                            }
                            className="w-full"
                            onClick={handleUploadPaymentDetails}
                        >
                            Upload Payment Receipt
                        </Button>

                        <Button
                            className="w-full bg-gray-100 text-primary lg:hidden "
                            onClick={() => setShowHistory(true)}
                        >
                            View for Payment History
                        </Button>
                    </>
                ) : (
                    <div className="w-full">
                        <AlertMessage
                            message="No payment available"
                            error={true}
                        />
                    </div>
                )}
            </div>
            <div className="w-0.1 bg-gray-200 hidden lg:block"></div>

            <div className="w-4/5 hidden lg:block">
                {/* @DESC:: 3rd @habib610 Mon April 07,2025 */}
                <div className="text-center bg-gray-100 py-1 rounded-sm mb-2.4">
                    <H4 className="sm:text-base 2xl:text-base ">
                        Payment History
                    </H4>
                </div>
                <div className=" h-[380px]">
                    <PaymentHistory data={history} />
                </div>
            </div>

            <div className="lg:hidden">
                <BottomDrawer
                    isOpen={showHistory}
                    onClick={() => setShowHistory(false)}
                    contentClass="bg-white "
                    showClose={true}
                >
                    <Container className="pb-6.4">
                        <div className="text-center bg-gray-100 py-1 rounded-sm mb-2.4">
                            <H4 className="sm:text-base 2xl:text-base ">
                                Payment History
                            </H4>
                        </div>
                        <div className=" h-[380px]">
                            <PaymentHistory data={history} />
                        </div>
                    </Container>
                </BottomDrawer>
            </div>
        </div>
    );
};

export default Confirmation;
